import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { WireReportComponent } from '../Wire/components/WireReport/wire-report.component';
import { HypeComponent } from '../../Common/Layout/components/Hype/hype.component';
import { AmplifyComponent } from '../Core/components/Amplify/amplify.component';
import { EditorRouteGuard } from '../Core/services/editor-route-guard';
import { WireRouteGuard } from '../Core/services/wire-route-guard';
import { WireComponent } from '../Wire/components/wire.component';
import { WireDeactivateGuard } from './guards/wire-deactivate.guard';
import { CreateNewActivateGuard } from '../../Common/Misc/services/create-new-activate.guard';

const amplifyRoutes: Routes = [
    {
        path: 'Amplify',
        component: AmplifyComponent,
        canActivate: [WireRouteGuard],
        children: [
            {
                path: 'editorial/wire/:wireId',
                canDeactivate: [WireDeactivateGuard],
                component: WireComponent
            },
            {
                path: 'wires/wire/:wireId',
                component: WireComponent,
                canDeactivate: [WireDeactivateGuard]
            },
            {
                path: 'wires/wire/:wireId/report',
                component: WireReportComponent
            },
            {
                path: 'wires/wire',
                component: WireComponent,
                canDeactivate: [WireDeactivateGuard],
                canActivate: [CreateNewActivateGuard],
                data: {title: 'Amplify.newswire.browserTitle'}
            },
            {
                path: 'editorial',
                canActivate: [EditorRouteGuard],
                component: HypeComponent,
                data: {title: 'Amplify.newswire.browserTitle'}
            },
            {
                path: 'wires',
                component: HypeComponent,
                data: {title: 'Amplify.newswire.browserTitle'}
            },
            {
                path: '**',
                redirectTo: '/Amplify'
            }
        ]
    }
];

@NgModule({
    imports: [
        RouterModule.forChild(amplifyRoutes)
    ],
    exports: [
        RouterModule
    ],
    providers: [
        WireDeactivateGuard
    ]
})
export class AmplifyRoutingModule { }
